import { useState } from "react";
import CustomSelect from "../../SelectSearch/CustomSelect";
import { FiX } from "react-icons/fi";

export const StockableIssuePopup = ({ item, onClose, onConfirm, costCenterOptions, loadingCC }) => {
    const [rows, setRows] = useState([{ costCenter: "", qty: "" }]);
    const totalIssued = rows.reduce((s, r) => s + (parseFloat(r.qty) || 0), 0);
    const remaining = item.quantity - totalIssued;

    const addRow = () => setRows(prev => [...prev, { costCenter: "", qty: "" }]);
    const removeRow = (i) => setRows(prev => prev.filter((_, idx) => idx !== i));
    const updateRow = (i, field, value) =>
        setRows(prev => prev.map((r, idx) => idx === i ? { ...r, [field]: value } : r));

    const valid =
        rows.length > 0 &&
        rows.every(r => r.costCenter && parseFloat(r.qty) > 0) &&
        Math.abs(totalIssued - item.quantity) < 0.001;

    return (
        <div
            style={{
                position: "fixed", inset: 0, zIndex: 100,
                background: "rgba(0,0,0,0.4)",
                display: "flex", alignItems: "center", justifyContent: "center",
            }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
        >
            <div className="bg-white rounded-xl shadow-xl w-full max-w-lg mx-4 overflow-hidden">
                <div className="p-4 border-b border-gray-100 flex items-center justify-between">
                    <div className="space-y-0.5">
                        <h3 className="text-sm font-semibold text-gray-900">
                            Issue to Cost Centers
                        </h3>
                        <p className="text-sm text-gray-500">
                            {item.ItemName} • Total Qty:{" "}
                            <span className="font-medium text-gray-700">
                                {item.quantity}
                            </span>
                        </p>
                    </div>

                    <button
                        onClick={onClose}
                        className="p-1.5 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition"
                    >
                        <FiX size={16} />
                    </button>
                </div>

                <div className="p-4 space-y-2 max-h-72 overflow-y-auto">
                    {rows.map((row, i) => (
                        <div key={i} className="flex gap-2 items-center">
                            <div className="flex-1 text-sm">
                                <CustomSelect
                                    options={costCenterOptions}
                                    value={row.costCenter}
                                    placeholder={loadingCC ? "Loading..." : "Select cost center"}
                                    onChange={(val) => updateRow(i, "costCenter", val)}
                                />
                            </div>
                            <input
                                type="number"
                                min="0"
                                step="any"
                                placeholder="Qty"
                                value={row.qty}
                                onChange={(e) => updateRow(i, "qty", e.target.value)}
                                className="w-24 px-3 py-1.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            {rows.length > 1 && (
                                <button
                                    onClick={() => removeRow(i)}
                                    className="p-1 rounded hover:bg-red-50 text-red-400 hover:text-red-600 transition"
                                >
                                    <FiX size={16} />
                                </button>
                            )}
                        </div>
                    ))}
                    <button onClick={addRow} className="text-blue-600 hover:text-blue-800 text-sm font-medium">
                        + Add cost center
                    </button>
                </div>

                <div className="px-4 pb-2">
                    <div className={`flex justify-between text-sm font-medium px-1 ${Math.abs(remaining) < 0.001 ? "text-green-600" : remaining < 0 ? "text-red-600" : "text-amber-600"}`}>
                        <span>Issued: {totalIssued.toFixed(2)}</span>
                        <span>
                            {remaining < 0
                                ? `Over by ${Math.abs(remaining).toFixed(2)}`
                                : remaining > 0
                                    ? `${remaining.toFixed(2)} remaining`
                                    : "Fully allocated"}
                        </span>
                    </div>
                </div>

                <div className="px-5 py-3 border-t border-gray-100 flex gap-2 justify-end">
                    <button onClick={onClose} className="px-4 py-1.5 text-sm border border-gray-200 rounded-md text-gray-600 hover:bg-gray-50">Cancel</button>
                    <button
                        onClick={() => valid && onConfirm(rows)}
                        disabled={!valid}
                        className="px-4 py-1.5 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-40 disabled:cursor-not-allowed"
                    >
                        Confirm Issue
                    </button>
                </div>
            </div>
        </div>
    );
};